import { Component, inject } from '@angular/core';
import { SharedModule } from "@primeng/api";
import { Table } from "@primeng/table";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ModalService } from '@shared/services/modal/modal.service';

@Component({
  selector: 'residential',
  standalone: true,
  imports: [
    SharedModule,
    Table,
    TranslatePipe
  ],
  templateUrl: './residential.component.html',
  styleUrl: './residential.component.scss'
})
export class ResidentialComponent {
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  maintenanceContracts = [
    {
      title: 'Heizungsreparatur',
      status: 'Abgeschlossen',
      date: '2023-10-15T09:00:00Z',
      assigned: 'Heizungsservice Schmidt',
    },
  ];
}
